// ====================== BASE URLs ======================
export const base_url = "https://stock-reco-be-dev-001-bbc5cma7fwbrc6ax.eastus-01.azurewebsites.net";
export const base_url_algo = "https://fa-algo-v2-backend.azurewebsites.net"
// ====================== DEFAULT USER / ACCOUNT ======================


// ====================== API ENDPOINTS ======================

// Auth
export const loginApiURL = `${base_url}/api/login`;

// Stocks
export const STOCK_SEARCH_API = `${base_url}/api/v1/stocks/search`;
// GET ?query={query}  → autocomplete

// (future-proofing 👇)
export const STOCK_DETAILS_API = (symbol) =>
  `${base_url}/api/v1/stocks/${symbol}`;

export const STOCK_RECOMMENDATION_API = `${base_url}/api/v1/recommendations`;

// ====================== COMMON HEADERS ======================
export const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

// ===============================================
// Brand constants for FinSight (Light + Dark theme)
// ===============================================

export const BRAND = Object.freeze({
  NAME: "FinSight",

  // 🎨 Primary Color Palette
  COLORS: {
    PRIMARY: "#0093fb",
    PRIMARY_DARK: "#0076c8",
    PRIMARY_LIGHT: "#e6f4ff",

    // 🌗 Light theme
    LIGHT: {
      BACKGROUND: "#ffffff",
      SURFACE: "#f8fafc",
      TEXT_PRIMARY: "#494949ff",
      TEXT_SECONDARY: "#475569",
      CHIP_BG: "#eef5ff",
      BORDER: "#e2e8f0",
    },

    // 🌑 Dark theme
    DARK: {
      BACKGROUND: "#0d1117",
      SURFACE: "#161b22",
      TEXT_PRIMARY: "#f8fafc",
      TEXT_SECONDARY: "#94a3b8",
      CHIP_BG: "#1e293b",
      BORDER: "#334155",
    },

    SUCCESS: "#16a34a",
    WARNING: "#f59e0b",
    ERROR: "#e11d48",
  },

  // 🧱 Spacing + Radius
  RADIUS: 16,
  SPACING: (n) => `${n * 8}px`,

  // 💨 Shadows
  SHADOWS: {
    LIGHT: "0 10px 30px rgba(0,0,0,0.08)",
    DARK: "0 10px 30px rgba(0,0,0,0.5)",
  },

  // 🪶 Fonts
  FONT_FAMILY: "Nunito Sans, sans-serif",
});
